<template>
  <div>
    <modal
      name="photoModal"
      :scrollable="true"
      delay="2000"
      width="100%"
      height="auto"
      style="z-index: 9998;"
      @closed="closeModal"
    >
      <div v-if="work!=null" :id="modalAreaPhotoId" class="modalArea">
        <div class="content clearfix">

          <section id="spotPhoto">
            <img :src="work.normalUrl" :alt="`${work.prefectures}${work.city}の写真`">
          </section><!-- /spotPhoto -->

          <div id="spotText">
            <section id="spotInfo" class="clearfix">
              <h1>{{work.address}}</h1>
              <div class="spotLocation">
                <p class="photographer"><span class="spotInfoSub">撮影: </span>{{work.photographer}} <span v-if="work.spotInformations && work.spotInformations.prize">[{{work.spotInformations.year}} {{work.spotInformations.prize}}]</span></p>
                <p class="latlon"><span class="spotInfoSub">経緯経度: </span>{{work.latitude}}, {{work.longitude}}</p>
              </div><!-- /info -->
            </section><!-- /spotInfo -->

            <hr />

            <div v-if="work.spotInformations && work.spotInformations.spotname">
              <section id="spotDetails">
                <h3>{{work.spotInformations.spotname}}</h3>
                <p style="white-space: pre-wrap;">{{work.spotInformations.spotinfo}}</p>
                <div class="link">
                  <a :href="work.spotInformations.spoturl" target="_blank">{{work.spotInformations.spoturl}}</a>
                </div>
              </section><!-- /spotDetails -->
              <hr />
            </div>

            <div v-if="work.spotInformations && work.spotInformations.comment">
              <section id="spotDetails">
                <h3>撮影者コメント</h3>
                <p style="white-space: pre-wrap;">{{work.spotInformations.comment}}</p>
              </section><!-- /spotDetails -->
            </div>
          </div><!-- /spotText -->
        </div><!-- /content -->
      </div><!-- /modalArea -->
      <div v-if="open" class="closeModalBotton fade" @click="closeModal"><img src="/img/blank.gif"></div>
    </modal>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: [
    'work',
    'open'
  ],
  data () {
    return {
    }
  },
  computed: {
    modalAreaPhotoId () {
      if (this.work !== null && this.work.height >= this.work.width) return 'modalAreaPhotoV'
      if (this.work !== null && this.work.height < this.work.width) return 'modalAreaPhotoH'
      return ''
    }
  },
  methods: {
    closeModal () {
      this.$emit('update:open', false)
      this.$modal.hide('photoModal')
      const path = '/'
      if (path !== this.$route.path) {
        this.$router.push(path)
      }
      document.title = '相模原市フォトスポットサイト'
    }
  },
  watch: {
    open (val) {
      if (val) {
        this.$modal.show('photoModal')
      }
    }
  }
}
</script>

<style>
.vm--overlay {
  background: rgba(0, 0, 0, 0.8) !important;
}
.vm--modal {
  background-color:rgba(0,0,0,0) !important;
}
.loading{
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
